import request from '@/utils/request'
// 获取总览的数据
export function fetchOverview(params = {}) {
  return request({
    url: '/merchant-api/trade/overview',
    method: 'get',
    params
  })
}

// 获取payment分析数据
export function fetchPaymentData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/payment',
    method: 'get',
    params
  })
}

// 获取disbursement 分析数据
export function fetchDisbursementData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/disbursement',
    method: 'get',
    params
  })
}

export function fetchTodayTotalData(params = {}) {
  return request({
    url: '/merchant-api/trade/total/statistics',
    method: 'get',
    params
  })
}

// 获取多币种 payment 分析数据
export function fetchMultiMchPaymentData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/multiMchPayment',
    method: 'get',
    params
  })
}

// 获取多币种 disbursement 分析数据
export function fetchMultiMchDisbursementData(params = {}) {
  return request({
    url: '/merchant-api/trade/analyse/multiMchDisbursement',
    method: 'get',
    params
  })
}

// 获取多币种今日统计数据
export function fetchMultiMchTodayTotalData(params = {}) {
  return request({
    url: '/merchant-api/trade/total/multiMchStatistics',
    method: 'get',
    params
  })
}

// 获取商户实时汇率
export function fetchMchExchangeRate(data = {}) {
  return request({
    url: '/merchant-api/mch/getMchExchangeRate',
    method: 'post',
    data
  })
}

// 获取多商户账户余额
export function fetchMchMultiInfo() {
  return request({
    url: '/merchant-api/mch/multiInfo',
    method: 'get'
  })
}

// 获取多币种账户总览数据
export function fetchMultiMchOverview(params = {}) {
  return request({
    url: '/merchant-api/trade/multiMchOverview',
    method: 'get',
    params
  })
}
